import React from "react";

export const defaultgenders = [
  {
    category: "Male",
    EmpReturn: "",
    EmpRetention: "",
    workerReturn: "",
    workerRetention: "",
  },
  {
    category: "Female",
    EmpReturn: "",
    EmpRetention: "",
    workerReturn: "",
    workerRetention: "",
  },
  {
    category: "Total",
    EmpReturn: "",
    EmpRetention: "",
    workerReturn: "",
    workerRetention: "",
  },
];

const ReturnToWorkRateTable = ({ returndata, setReturnData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...returndata];
    updated[index][field] = value;
    setReturnData(updated);
  };

  return (
    <div
      style={{
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#d8cbd4" }}>
            <th rowspan={2} style={cellHeader}>
              Gender
            </th>
            <th colspan="2" style={cellHeader}>
              Permanent Employees
            </th>
            <th colspan="2" style={cellHeader}>
              Permanent Workers
            </th>
          </tr>

          <tr style={{ backgroundColor: "#d8cbd4" }}>
            <th style={cellHeader}>Return to work rate</th>
            <th style={cellHeader}>Retention rate</th>
            <th style={cellHeader}>Return to work rate</th>
            <th style={cellHeader}>Retention rate</th>
          </tr>
        </thead>
        <tbody>
          {returndata.map((row, index) => (
            <tr key={index}>
              <td style={{ ...cellHeader, backgroundColor: "#d8cbd4" }}>
                <strong>{row.category}</strong>
              </td>
              <td style={cell}>
                <input
                  type="text"
                  value={row.EmpReturn}
                  onChange={(e) =>
                    handleChange(index, "EmpReturn", e.target.value)
                  }
                  style={inputStyle}
                  placeholder="Enter"
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  value={row.EmpRetention}
                  onChange={(e) =>
                    handleChange(index, "EmpRetention", e.target.value)
                  }
                  style={inputStyle}
                  placeholder="Enter"
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  value={row.workerReturn}
                  onChange={(e) =>
                    handleChange(index, "workerReturn", e.target.value)
                  }
                  style={inputStyle}
                  placeholder="Enter"
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  value={row.workerRetention}
                  onChange={(e) =>
                    handleChange(index, "workerRetention", e.target.value)
                  }
                  style={inputStyle}
                  placeholder="Enter"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const cellHeader = {
  border: "1px solid #000",
  padding: "8px",
  textAlign: "center",
  fontWeight: "bold",
};
const spanHeader = {
  fontWeight: "bold",
  textAlign: "center",
};

const cell = {
  border: "1px solid #ccc",
  padding: "6px",
  textAlign: "center",
};

const inputStyle = {
  width: "100%",
  padding: "5px",
  borderRadius: "4px",
  border: "1px solid gray",
};

export default ReturnToWorkRateTable;
